import { Component } from '@angular/core';
import { App, NavController, NavParams, ViewController, LoadingController, AlertController, ModalController, PopoverController, Events, FabContainer, ToastController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { MonedaPage } from '../moneda/moneda';
import moment from 'moment'
import { File } from '@ionic-native/file';
/**
 * Generated class for the CxcPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-cxc',
  templateUrl: 'cxc.html',
})
export class CxcPage {
  modal: any = false
  clientes: any = []
  aux: any = []
  resBusq: any = []
  user: any = {}
  skip = 0
  fin = 9
  skip_buscar = 0
  loading = false
  loadModal : any 
  busqueda: any = ''
  timeout: any = ''
  fechaAct: any
  actSearch = false
  cargando = false
  successs = false
  errorr = false
  super = false
  multimoneda = false
  moneda: any = 'USD'
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public popCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    public app: App,
    public viewCtrl : ViewController,
    public events : Events,
    public file:File,
    public http : HttpProvider,
    public alertCtrl: AlertController,
    public modlCtrl : ModalController,
    public toastCtrl: ToastController
    ) {
      events.subscribe('moneda:update', ()=>{
        this.updateMoneda()
      })
      this.init();     
  }

  async init() {
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
    if(window.localStorage.multimoneda && window.localStorage.multimoneda == "true"){
      this.multimoneda = true
    }
    if(window.localStorage.getItem('super')){
      this.super = true
    }else{
      this.user.co_ven = window.localStorage.getItem('co_ven')
    }
    if(this.navParams.data.modal){
      this.modal = this.navParams.data.modal
    }
    let infor = '[]'
    if(window.localStorage.getItem('clientesCxc')){
      infor = await this.file.readAsText(this.file.dataDirectory, 'clientesCxc.json');
    }
    let cli = JSON.parse(infor)
    if (cli && cli.length > 0) {
      this.skip = 0
      this.fin = 10
      this.aux = cli
      this.clientes = this.aux.slice(this.skip, this.fin)
      this.skip+=10
      this.fin+=10
      this.getClientes2(this.user.co_ven)
    } else {
      this.getClientes(this.user.co_ven)
    }
  }

  async writeJSON(filename, object) {
    let save = await this.file.writeFile(this.file.dataDirectory, filename, JSON.stringify(object), {replace:true})
    window.localStorage.setItem('clientesCxc', 'true');
    return save
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  getClientes2(ven){
    this.fechaAct = window.localStorage.getItem('horaClientesCxc')
    if(window.localStorage.getItem('network') === '1') {
      this.cargando = true
      this.successs = false
      this.errorr = false
      const url = this.super ? `cliente/supCXC?vendedores=${window.localStorage.getItem('vendedores')}` : `cliente/venCXC/${ven}`
      this.http.get(url).subscribe(
        (res:any=[])=>{
          if (res && res.length > 0) {
            this.aux = res
            this.clientes = res.slice(0, this.fin)
            this.writeJSON('clientesCxc.json', this.aux)
            window.localStorage.setItem('horaClientesCxc', moment().format('DD-MM-YYYY H:mm A'));
            this.fechaAct = window.localStorage.getItem('horaClientesCxc')
          }
          this.cargando = false
          this.successs = true
        }, err=>{
          this.errorr = true
          this.cargando = false
        })
    } else {
      this.errorr = true
      this.cargando = false
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  close(){
    this.viewCtrl.dismiss()
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  showMonedas2(){
    const pop = this.popCtrl.create(MonedaPage, {}, {cssClass: 'popppover'})
    pop.present()
  }

  async doInfinite(infiniteScroll){
    if (!this.actSearch) {
      this.clientes = this.clientes.concat(this.aux.slice(this.skip, this.fin))
    } else {
      this.clientes = this.clientes.concat(this.resBusq.slice(this.skip, this.fin))
    }
    this.skip+=10
    this.fin+=10
    infiniteScroll.complete()
  }

  calculoDias(item) {
    let fecha1 = moment(item.fec_emis);
    let fecha2 = moment(item.fec_venc);
    return fecha2.diff(fecha1, 'days')
  }

  calculoTranscurridos(item) {
    let fecha1 = moment(item.fec_emis);
    let fecha2 = moment();
    return fecha2.diff(fecha1, 'days')
  }

  transform(value, tasa) {
    if(value){
      let val = (parseFloat(value) / parseFloat(tasa)).toFixed(2)
      let val2 = val.toString().split('.')
      if(val2.length > 1) return val2[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val2[1].slice(0,2);
      return val2[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  reset(){
    if(this.busqueda.length === 0) {
      this.resBusq = []
      this.actSearch = false
      this.clientes = this.aux.slice(0, 9)
      this.skip = 10
      this.fin = 19
    }
  }

  buscar(){
    this.resBusq = []
    this.resBusq = this.aux.filter((el) => {
      let arry = this.busqueda.split(' ')
      if (arry.length === 1) {
        return el.cli_des.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1 ||
          el.co_cli.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1
      } else {
        let cont = 0
        let cont2 = 0
        for (let i = 0; i < arry.length; i++) {
          if (el.cli_des.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
            cont++
          }
          if (el.co_cli.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
            cont2++
          }
          el.puntuacion = (cont > cont2) ? cont : cont2
        }
        if (cont > 0 || cont2 > 0) {
          return el
        }
      }
    })
    this.resBusq.sort(function(a, b) {
      return b.puntuacion - a.puntuacion;
    });
    this.skip=0
    this.fin=9
    this.clientes = this.resBusq.slice(this.skip, this.fin)
    this.skip+=10
    this.fin+=10
    this.actSearch = true
  }

  getClientes(ven, search=null, infiniteScroll=null){
    if(window.localStorage.getItem('network') === '1'){
      this.cargando = true
      this.successs = false
      this.errorr = false
      this.ActivarLoading()
      const url = this.super ? `cliente/supCXC?vendedores=${window.localStorage.getItem('vendedores')}` : `cliente/venCXC/${ven}`
      this.http.get(url).subscribe(
        (res:any)=>{
          this.DesactivarLoading()
          this.aux = res
          this.clientes = res.slice(this.skip, this.fin)
          this.skip+=10
          this.fin+=10
          this.writeJSON('clientesCxc.json', this.aux)
          window.localStorage.setItem('horaClientesCxc', moment().format('DD-MM-YYYY H:mm A'));
          this.fechaAct = window.localStorage.getItem('horaClientesCxc')
          this.cargando = false
          this.successs = true
        },
        error=>{
          this.errorr = true
          this.cargando = false
          this.DesactivarLoading()
          if(search){
            this.loading = false
          }
          if(infiniteScroll){
            infiniteScroll.complete()
          }
          console.log(error)
          this.alertCtrl.create({
            title: 'Atención',
            subTitle:'No posee conexión a internet, intente nuevamente.',
            buttons:[
              {
                text:'Aceptar',
                cssClass:'btnAceptar',
                handler:()=>{
                }
              }
            ]
          }).present()
        }
      )
    } else {
      this.errorr = true
      this.cargando = false
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/cxc/cxc.ts